import { NgModule } from "@angular/core";
import { CeloFileDropDirective } from "./celo-file-drop.directive";
import { CeloFileSelectDirective } from "./celo-file-select.directive";

/** Drop-in replacement for ng2-file-upload's FileUploadModule. */
@NgModule({
  declarations: [CeloFileSelectDirective, CeloFileDropDirective],
  exports: [CeloFileSelectDirective, CeloFileDropDirective],
})
export class CeloFileUploadModule {}
